/**
 * @fileoverview
 * Functions to access persisted player state.
 */

import { SOFT_PIP_PLAYER_STATE_KEY } from '@core/pictureInPicture/keys'
import { getSessionStorage } from '@core/storage/getStorage'
import { removeFromHistoryState } from '@core/storage/historyState'

import type { ISoftPIPPlayerState } from './types'

/**
 * Store the Soft PIP player state in session storage and history state.
 * @param value - The Soft PIP player state to store.
 */
export function setPersistedPlayerState(value: ISoftPIPPlayerState) {
  getSessionStorage().setItem(SOFT_PIP_PLAYER_STATE_KEY, JSON.stringify(value))
}

/**
 * Get the Soft PIP player state from session storage.
 * @returns The Soft PIP player state.
 */
export function getPersistedPlayerState(): ISoftPIPPlayerState | undefined {
  const value = getSessionStorage().getItem(SOFT_PIP_PLAYER_STATE_KEY)
  return value ? JSON.parse(value) : undefined
}

/**
 * Clear the Soft PIP player state from session storage and history state.
 */
export function clearPersistedPlayerState() {
  removeFromHistoryState(SOFT_PIP_PLAYER_STATE_KEY)
  getSessionStorage().removeItem(SOFT_PIP_PLAYER_STATE_KEY)
}
